var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmericanFootball = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "American-Football-Helmet--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "American Football Helmet Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 16H12.5a0.5 0.5 0 0 1 -0.5 -0.5 3.5 3.5 0 0 1 3.5 -3.5H22a1 1 0 0 0 0.72 -0.31A1 1 0 0 0 23 11c0 -0.43 -0.07 -0.86 -0.13 -1.28a0.51 0.51 0 0 0 -0.5 -0.42H14.5a5.25 5.25 0 0 0 -5.25 5.2 0.5 0.5 0 0 0 0.31 0.46 2.75 2.75 0 1 1 -2.12 0 0.5 0.5 0 0 0 0.31 -0.46 6.76 6.76 0 0 1 6.75 -6.75h8.75a0.75 0.75 0 0 0 0 -1.5H22a0.51 0.51 0 0 1 -0.4 -0.25A11.5 11.5 0 0 0 0 11.5c0 5.25 3.91 10.19 8.53 11.14 0.4 0.08 0.36 0.07 2.35 0.29a2 2 0 0 1 0.73 0.23 7 7 0 0 0 3.33 0.84H21a3 3 0 0 0 3 -3v-4a1 1 0 0 0 -1 -1Zm-9 5.27a0.5 0.5 0 0 1 -0.66 0.47 4.75 4.75 0 0 1 -1.11 -0.54 0.5 0.5 0 0 1 -0.23 -0.42V18.5a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 0 1 0.5 0.5Zm4 0.23a0.5 0.5 0 0 1 -0.5 0.5h-1a0.5 0.5 0 0 1 -0.5 -0.5v-3a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 0 1 0.5 0.5Zm4 -0.5a1 1 0 0 1 -1 1h-0.5a0.5 0.5 0 0 1 -0.5 -0.5v-3a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 17.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 1 0 -2.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmericanFootball);
export default ForwardRef;